import React from 'react'
import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'

interface GrowthPlanBottomSheetProps {
  onDismiss: () => void
  ScreenName: string
}

export const GrowthPlanBottomSheet: React.FC<GrowthPlanBottomSheetProps> = ({ onDismiss }) => {
  return (
    <BottomSheetContent
      heading='Why we recommend investing in a Growth plan, instead of IDCW'
      logoSrc='/images/power-rebalance/manual-book.png'
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-medium !text-[22px]'
    >
      <div className='text-grey40 flex flex-col gap-6'>
        <p className='text-sm font-normal'>Here’s why Growth plans are better, compared to IDCW :</p>

        <div className='flex flex-col gap-1'>
          <p className='text-sm leading-[1.5]'>
            <span className='font-bold text-[#232323]'>Your money compounds without interruptions</span>
            <br />
            In Growth plans, all gains stay invested, helping your investment compound more over time. Whereas in IDCW
            plans, payouts reduce your invested amount, hindering your long term compounding
          </p>
        </div>

        <div className='flex flex-col gap-1'>
          <p className='text-sm leading-[1.5]'>
            <span className='font-bold text-[#232323]'>More tax-efficient for long-term investors</span> You are taxed
            only at the time of redemption, unlike the payouts received from IDCW funds - which are taxable as per your
            income tax bracket, every time the fund distributes cash.
          </p>
        </div>

        <p className='text-sm font-normal leading-[1.5]'>
          If you prefer regular cashflows, you can opt for an IDCW plan. But for long-term wealth creation, we recommend
          switching to the Direct Growth plan of the fund
        </p>
      </div>
    </BottomSheetContent>
  )
}
